document.addEventListener('DOMContentLoaded', function() {
  // Select elements
  const facetsOpenTriggers = document.querySelectorAll('.facets_open-trigger');
  const mwFacets = document.querySelector('.mw-facets');
  const drawerContent = document.querySelector('.mw-drawer__content');
  const overlay = document.querySelector('.overlay');
  const closeButtons = document.querySelectorAll('.drawer__close-btn, .js-close-drawer');
  const bodyElement = document.body; // Referenz zum Body-Element hinzugefügt
  
  // Get all filter toggles from the facet drawer for easy access
  const filterToggles = mwFacets ? mwFacets.querySelectorAll('.filter__toggle') : [];
  
  // Function to open facets and scroll to the correct filter
  function openFacets() {
    // Get the trigger index (which filter to open)
    const triggerIndex = parseInt(this.classList.toString().match(/trigger--(\d+)/)?.[1]) || 0;
    
    // Mark this trigger as active, and others as inactive if desired
    facetsOpenTriggers.forEach(trigger => {
      if (trigger === this) {
        trigger.classList.add('open');
      } else {
        // Optional: if you want only one trigger to be "open" at a time
        // trigger.classList.remove('open');
      }
    });
    
    // Open the facet drawer
    if (mwFacets) {
      mwFacets.classList.add('open');
      mwFacets.setAttribute('aria-hidden', 'false');
      
      // Body Element die Klasse 'fixed' hinzufügen wenn Facets geöffnet sind
      bodyElement.classList.add('fixed-overflow');
      
      // Wait a short time for drawer to start opening, then scroll
      setTimeout(() => {
        // Scroll to the corresponding filter toggle based on index
        // Note: We need to offset by the number of other elements at the beginning of the list
        // Typically first "filter" might be the sorting option which we want to skip
        // So we add 1 to account for the sorting element if it exists
        const offsetIndex = document.querySelector('#filter-sort') ? triggerIndex + 1 : triggerIndex;
        
        if (filterToggles && filterToggles.length >= triggerIndex && triggerIndex > 0) {
          // Get the target filter toggle
          const targetToggle = filterToggles[offsetIndex - 1]; // -1 because array is 0-indexed
          
          if (targetToggle) {
            // Find the parent details element and open it
            const parentDetails = targetToggle.closest('details');
            if (parentDetails) {
              parentDetails.open = true;
            }
            
            // Scroll the drawer content to show this filter
            if (drawerContent) {
              // Add some offset to account for header
              const headerHeight = mwFacets.querySelector('.drawer__header')?.offsetHeight || 0;
              drawerContent.scrollTop = targetToggle.offsetTop - headerHeight - 10;
            }
          }
        }
      }, 100); // Small delay to ensure drawer is starting to open
    }
    
    // Show overlay
    if (overlay) {
      overlay.classList.add('is-visible');
    }
  }
  
  // Function to close facets
  function closeFacets() {
    // Remove open class from all triggers
    facetsOpenTriggers.forEach(trigger => {
      trigger.classList.remove('open');
    });
    
    // Close the facet drawer
    if (mwFacets) {
      mwFacets.classList.remove('open');
      mwFacets.setAttribute('aria-hidden', 'true');
      
      // Die Klasse 'fixed' vom Body-Element entfernen wenn Facets geschlossen werden
      bodyElement.classList.remove('fixed-overflow');
    }
    
    // Hide overlay
    if (overlay) {
      overlay.classList.remove('is-visible');
    }
  }
  
  // Store filter IDs and labels for matching
  const filterMap = [];
  if (filterToggles && filterToggles.length > 0) {
    filterToggles.forEach((toggle, index) => {
      const label = toggle.querySelector('.flex-auto')?.textContent.trim();
      if (label) {
        filterMap.push({
          index: index + 1,
          label: label
        });
      }
    });
  }
  
  // Add click event to open facets for each trigger
  facetsOpenTriggers.forEach((trigger, index) => {
    // Match trigger label with filter labels for better targeting
    const triggerLabel = trigger.querySelector('.flex-auto')?.textContent.trim();
    
    // Store the matched filter index directly on the trigger for later use
    if (triggerLabel) {
      const matchedFilter = filterMap.find(filter => filter.label === triggerLabel);
      if (matchedFilter) {
        trigger.setAttribute('data-filter-index', matchedFilter.index);
      } else {
        trigger.setAttribute('data-filter-index', index + 1);
      }
    } else {
      trigger.setAttribute('data-filter-index', index + 1);
    }
    
    trigger.addEventListener('click', openFacets);
  });
  
  // Add click events to close facets
  if (overlay) {
    overlay.addEventListener('click', closeFacets);
  }
  
  // Add click events to all close buttons
  closeButtons.forEach(button => {
    button.addEventListener('click', closeFacets);
  });
});